// extracted by mini-css-extract-plugin
module.exports = {"bundles":"JPBundle_bundles___PRyT"};